(function () {
  function cleanCanonical() {
    var link = document.querySelector('link[rel="canonical"]');
    if (!link || !link.href) return;

    try {
      var url = new URL(link.href, window.location.origin);

      // Remove UX-only parameters
      url.searchParams.delete('view');

      // Preserve pagination (?page=)
      link.href = url.toString();
    } catch (e) {
      // Fail silently
    }
  }

  // Run once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanCanonical);
  } else {
    cleanCanonical();
  }

  // Re-run after third-party scripts mutate <head>
  setTimeout(cleanCanonical, 50);
  setTimeout(cleanCanonical, 250);
  setTimeout(cleanCanonical, 1000);
})();